import { buildProperFormatDate } from 'util/buildProperFormatDate';
import { checkIsProperDate } from 'util/checkIsProperDate';

import { DemographicKind } from 'api/dto/Demographic.dto';
import { DEFAULT_DATE_FORMAT } from 'shared/constants';
import dayjs, { Dayjs } from 'dayjs';

import { ClassificationDateDto } from './ClassificationDate.dto';

export type ClassificationDto = {
  id?: number;
  title?: string;
  position?: number;
  demographyId?: number;
  demographyKind?: number;
};

export type ClassificationModel = {
  id?: number;
  title?: string;
  value?: Dayjs;
  position?: number;
  demographyId?: number;
  demographyKind?: DemographicKind;
};

export function mapClassificationModelToDto(model: ClassificationModel): ClassificationDto {
  return {
    id: model.id,
    title: model.title,
    position: model.position,
  };
}

export function mapClassificationDtoToModel(
  dto: ClassificationDto,
  classificationsDate?: ClassificationDateDto[],
): ClassificationModel {
  const classificationDate =
    classificationsDate && classificationsDate.find((item) => item.demography === dto.demographyId);

  return {
    id: dto.id,
    title: dto.title,
    position: dto.position,
    demographyId: dto.demographyId,
    demographyKind: dto.demographyKind,
    value: classificationDate
      ? checkIsProperDate(classificationDate.value)
        ? dayjs.utc(classificationDate.value, DEFAULT_DATE_FORMAT)
        : dayjs.utc(buildProperFormatDate(classificationDate.value), DEFAULT_DATE_FORMAT)
      : null,
  };
}
